import * as betgalaxy from './Banner.styles.betgalaxy';
import * as betprofessor from './Banner.styles.betprofessor';
import * as goldenrush from './Banner.styles.goldenrush';
import * as puntcity from './Banner.styles.puntcity';
import * as puntgenie from './Banner.styles.puntgenie';
import * as questbet from './Banner.styles.questbet';
import * as sterlingparker from './Banner.styles.sterlingparker';
import * as vikingbet from './Banner.styles.vikingbet';
import * as volcanobet from './Banner.styles.volcanobet';
import * as forsport from './Banner.styles.forsport';
import * as fiestabet from './Banner.styles.fiestabet';
import * as sugarcastle from './Banner.styles.sugarcastle';
import * as oldgill from './Banner.styles.oldgill';
import * as buffalobet from './Banner.styles.buffalobet';
import * as betroyale from './Banner.styles.betroyale';
import * as juicybet from './Banner.styles.juicybet';
import * as slambet from './Banner.styles.slambet';
import * as goldenbet888 from './Banner.styles.goldenbet888';
import * as gigabet from './Banner.styles.gigabet';
import * as templebet from './Banner.styles.templebet';
import * as hyperbet from './Banner.styles.hyperbet';
import * as bet777 from './Banner.styles.bet777';
import * as chromabet from './Banner.styles.chromabet';
import * as titanbet from './Banner.styles.titanbet';
import * as bet575 from './Banner.styles.bet575';
import * as betblast from './Banner.styles.betblast';
import * as pyramidbet from './Banner.styles.pyramidbet';
import * as magnumbet from './Banner.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  buffalobet,
  oldgill,
  sugarcastle,
  betgalaxy,
  betprofessor,
  goldenrush,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  fiestabet,
  betroyale,
  juicybet,
  slambet,
  goldenbet888,
  gigabet,
  templebet,
  hyperbet,
  bet777,
  chromabet,
  titanbet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
